import { render } from "./DeletePhoto.vue?vue&type=template&id=3c9d3217"
import script from "./DeletePhoto.vue?vue&type=script&lang=js"
export * from "./DeletePhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__